import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { FaLinkedin, FaGithub } from 'react-icons/fa';

import './Header.css';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  
  // Change header style on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    
    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  return (
    <Navbar 
      expand="lg" 
      fixed="top"
      className={`header ${scrolled ? 'scrolled' : ''}`}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" className="logo">
          <span className="logo-text">Ajyendra Singh</span>
          <span className="logo-subtitle">Microsoft Dynamics 365 Expert</span>
        </Navbar.Brand>
        
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link as={NavLink} to="/" end>Home</Nav.Link>
            <Nav.Link as={NavLink} to="/about">About</Nav.Link>
            <Nav.Link as={NavLink} to="/projects">Projects</Nav.Link>
            {/* <Nav.Link as={NavLink} to="/blog">Blog</Nav.Link> */}
            <Nav.Link as={NavLink} to="/contact">Contact</Nav.Link>
          </Nav>
          
          <div className="social-links">
            <a href="https://linkedin.com/in/ajyendra-singh" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaLinkedin />
            </a>
            <a href="https://github.com/ajyendrasingh" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <FaGithub />
            </a>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;